export const CHARTING_UNCATEGORIZED_CATEGORY_ID = 0;
export const DEFAULT_CREATE_EDIT_CATEGORY_ID = 0;
